// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QXGkXhEshSdnhlr1nwyb {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

.DPyznNSbN0LR26Fgsn2s {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.zCZZAjAgVq7NJxpvNpQo {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.sYwELhMfhTKGsmqyu92O {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

.N4PzYP_7fso3aQ7Nzi6W {
  display: flex;
  flex-direction: row;
  column-gap: 32px;
}

.PL7NAuI5xZ7EimmFY4DV {
  display: flex;
  flex-direction: row;
  column-gap: 4px;
}

.O1kZdAzKsgFt8L4GuPlU {
  font-family: Bai Jamjuree;
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
}

.LVmx6Jo2FVMCcQQ3NIes {
  font-family: Bai Jamjuree;
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
}

.iKNBtSaiXXSg7kY2MQhv {
  font-family: Figtree;
  font-weight: 400;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
}

.c7qt_YROM50nOHl5yApS {
  min-width: fit-content;
  background: rgba(0, 0, 0, 0.6) !important;
}

.S_vf6LGEVhESTvEU1j3t {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  width: 100%;
  height: 50px;
}

.gyYdgxfKNaxkNJNmyxX9 {
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 18rem);
  overflow-y: auto;
}

.lvWIW7wjtvhpkwtrAY0W {
  max-width: 40%;
}

.WmUDau4WA7FENEBqpVm9 {
  flex-grow: 1;
}

.alMoVeuIvnQyClzcjJ5j {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ZCxBXH8jS5XM0x6xmOLv {
  width: 40vw;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
}

.rFeBpoNKTOTdfLwEHDp1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.qbGgEEg4a34AJDY62H2c {
  width: 50px;
  height: 50px;
}

.Q5DrcE5DeeuKXBNWtqzo {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/screens/RankingAdministration/RankingAdministration.module.scss"],"names":[],"mappings":"AAIA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,yCAAA;AAHJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAHJ","sourcesContent":[".mainIdoContainer {\r\n\r\n}\r\n\r\n.idoAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 32px;\r\n}\r\n\r\n.rankingHeader {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.stakerContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n}\r\n\r\n.settingsContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 32px;\r\n}\r\n\r\n.settingsRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 32px;\r\n}\r\n\r\n.valueContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 4px;\r\n}\r\n\r\n.settingsHeader {\r\n    font-family: Bai Jamjuree;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n    color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.valueLabel {\r\n    font-family: Bai Jamjuree;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n    color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.value {\r\n    font-family: Figtree;\r\n    font-weight: 400;\r\n    font-size: 18px;\r\n    color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.tabSelector {\r\n    min-width: fit-content;\r\n    background: rgba(0, 0, 0, 0.6) !important;\r\n}\r\n\r\n\r\n.stakerHeaderContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 16px;\r\n    width: 100%;\r\n    height: 50px;\r\n}\r\n.tableContainer {\r\n    height: 100%;\r\n    width: 100%;\r\n    max-height: calc(100vh - 18rem);\r\n    overflow-y: auto;\r\n}\r\n\r\n.walletInputContainer {\r\n    max-width: 40%;\r\n}\r\n\r\n.flexGrower {\r\n    flex-grow: 1;\r\n}\r\n\r\n.rankingModalContainer {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.rankingModalContent {\r\n    width: 40vw;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n    padding: 16px;\r\n    background-color: white;\r\n    border-radius: 8px;\r\n}\r\n\r\n.buttonContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n\r\n.rankImage {\r\n    width: 50px;\r\n    height: 50px;\r\n}\r\n\r\n.addManualXpContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"idoAdminContainer": `QXGkXhEshSdnhlr1nwyb`,
	"rankingHeader": `DPyznNSbN0LR26Fgsn2s`,
	"stakerContainer": `zCZZAjAgVq7NJxpvNpQo`,
	"settingsContainer": `sYwELhMfhTKGsmqyu92O`,
	"settingsRow": `N4PzYP_7fso3aQ7Nzi6W`,
	"valueContainer": `PL7NAuI5xZ7EimmFY4DV`,
	"settingsHeader": `O1kZdAzKsgFt8L4GuPlU`,
	"valueLabel": `LVmx6Jo2FVMCcQQ3NIes`,
	"value": `iKNBtSaiXXSg7kY2MQhv`,
	"tabSelector": `c7qt_YROM50nOHl5yApS`,
	"stakerHeaderContainer": `S_vf6LGEVhESTvEU1j3t`,
	"tableContainer": `gyYdgxfKNaxkNJNmyxX9`,
	"walletInputContainer": `lvWIW7wjtvhpkwtrAY0W`,
	"flexGrower": `WmUDau4WA7FENEBqpVm9`,
	"rankingModalContainer": `alMoVeuIvnQyClzcjJ5j`,
	"rankingModalContent": `ZCxBXH8jS5XM0x6xmOLv`,
	"buttonContainer": `rFeBpoNKTOTdfLwEHDp1`,
	"rankImage": `qbGgEEg4a34AJDY62H2c`,
	"addManualXpContainer": `Q5DrcE5DeeuKXBNWtqzo`
};
export default ___CSS_LOADER_EXPORT___;
